<script>
export default {
    name: "EditRole",

    props: {
        userconfig: Object,
        showModal: Boolean,
    },

    methods: { 

        updateUserconfig () {
            this.$root.loading = true;
            this.$http.post(`Admin/ModUserConfigs`, this.userconfig).then(response => {
                this.$root.loading = false;
                this.$emit('closeModal');
                window.Swal.fire({ type: 'success', title: response.data });
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/2 w-2/3">
      <template v-slot:title>
        <h5 class="font-medium text-sm">Edit user Confg:<ul> {{ userconfig.description }}</ul></h5>
      </template>
      <template v-slot:modal-body>
        <div class="flex flex-wrap -m-3">
            <div class="md:w-1/2 w-1/2 p-tiny">
                <label for="grid-name" class="label-control">Value:</label>
                <input type="number" v-model="userconfig.value" id="grid-name" class="input-control input-sm text-xs">
            </div>
            
            <div class="w-1/2 p-tiny mt-4">
                <label for="grid-status" class="label-control">Status
                    <input type="checkbox" v-model="userconfig.valueBit" id="grid-status"></label>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs rounded mr-4" @click="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
        <button class="btn-primary btn-sm text-xs rounded" @click.prevent="updateUserconfig"><i class="fa fa-save"></i> Update</button>
      </template>
    </tail-modal>
</template>
